module.exports = __webpack_public_path__ + "static/media/living.205aec2d.svg";